export default __webpack_public_path__ + "static/media/docIcon.0f42e6de.svg";